import { ActionContext } from "vuex";
import TYPES from "./types";
import { RootState } from "./index";
import request from "~~/utils/request";
import { email as api } from "~~/const/apis";
import { CHANNEL_EMAIL, AccountType } from "~/types/account";

interface IEmailMsg {
  lead_id: string;
  email_hash: string;
}
interface State {
  emailMsg: IEmailMsg;
}

export const state = (): State => ({
  emailMsg: {
    lead_id: "",
    email_hash: ""
  }
});

export const mutations = {
  [TYPES.SET_EMAIL_MSG](state: State, emailMsg: IEmailMsg) {
    state.emailMsg = emailMsg;
  }
};

export const actions = {
  validateLeadId({ state, commit }: ActionContext<State, RootState>) {
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async (resolve, reject) => {
      const { lead_id, email_hash } = state.emailMsg;
      if (!lead_id || !email_hash) return reject(new Error("Invalid leadId"));
      const { data, code, msg } = await request.post(
        api.validate_leadid,
        state.emailMsg
      );
      if (code === 0) {
        if (!data) {
          reject(new Error("Invalid leadId"));
        }
        resolve(true);
      } else {
        reject(new Error(msg));
      }
    });
  },
  async getSubscribeConfig(
    { commit, dispatch }: ActionContext<State, RootState>,
    leadIds: string[]
  ) {
    const validResult = await dispatch("validateLeadId").catch(err =>
      String(err).replace("Error: ", "")
    );
    if (validResult === true) {
      return request.post(api.subscribe_config, {
        account_type: AccountType.LEAD,
        account_ids: leadIds,
        channels: [CHANNEL_EMAIL]
      });
    } else {
      return {
        data: {},
        code: -1,
        msg: validResult
      };
    }
  },
  async updateSubscribeConfig(
    { commit, dispatch }: ActionContext<State, RootState>,
    data: { leadId: string; update_confs: any }
  ) {
    const validResult = await dispatch("validateLeadId").catch(err =>
      String(err).replace("Error: ", "")
    );
    if (validResult === true) {
      return request.post(api.update_subscribe_config, {
        account_type: AccountType.LEAD,
        account_id: data.leadId,
        update_confs: data.update_confs
      });
    } else {
      return {
        code: -1,
        msg: validResult
      };
    }
  },
  reportUnsubscribeMsg(
    { commit }: ActionContext<State, RootState>,
    data: { recipient_trace_id: string; sign: string, attr_sys_version: string}
  ) {
    const { recipient_trace_id, sign, attr_sys_version } = data;
    if (recipient_trace_id && sign) {
      request.get(api.behavior_report, {
        report_type: "unsubscribe",
        recipient_trace_id,
        sign,
        attr_sys_version
      });
    }
  }
};
